import UIBadge from 'UIComponents/badge/UIBadge';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const ViewBadge = ({
  viewId
}) => {
  if (viewId === 'deal_collaborator') {
    return /*#__PURE__*/_jsx(UIBadge, {
      use: "new",
      className: "m-left-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.standardViews.objectSection.newBadge"
      })
    });
  }
  return null;
};